import { render, staticRenderFns } from "./AdditionalInformationCard.vue?vue&type=template&id=623be972&scoped=true&"
import script from "./AdditionalInformationCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformationCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalInformationCard.vue?vue&type=style&index=0&id=623be972&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623be972",
  null
  
)

export default component.exports